export class ocrHistoryConst {
    public static headerTable = [
        { field: 'dateStart', title: 'Fecha Inicio', cell: (row) => `${new Date(row.dateStart).toLocaleDateString() + " - " + new Date(row.dateStart).toLocaleTimeString()}`, class: (row) => `` },
        { field: 'dateEnd', title: 'Fecha Fin', cell: (row) => `${new Date(row.dateEnd).toLocaleDateString() + " - " + new Date(row.dateEnd).toLocaleTimeString()}`, class: (row) => `` },
        { field: 'invoiceNumber', title: 'Gasto', cell: (row) => `${row.invoiceNumber}`, class: (row) => `` },
        { field: 'fileName', title: 'Fichero', cell: (row) => `${row.fileName}`, class: (row) => `` },
        { field: 'numberPages', title: 'Nº páginas', cell: (row) => `${row.numberPages}`, class: (row) => `` }
    ];
}

